/*import {useState, useEffect} from 'react';*/

const Reponse = ({question}) => {

	if(question.type_rep === 'radio' || question.type_rep === 'checkbox') {
    return <div className="reponse qcm">
      {question.reps.map((rep, k) => 
         <label key={k}>
       {rep}
        </label>
      )}
    </div>
  } else if(question.type_rep === 'field') {
    let fields = question.field.split('_')
    if(fields.length % 2 && fields.length > 2) {
      return <p>
		        {fields.map((e, k0) => 
		         k0 % 2 ? <input key={k0} type="text" size={e.length} value={e} onChange={(e)=>false} style={{textAlign:"center", color:"#314159", fontSize:"1em", border:"none", borderBottom:"1px solid"}} /> : e+' '
		        )}
		      </p>
    } else {
    return 	<p> 
		      {question.field}
		    </p>
    }
  }
  else {
    return <p></p>
  }
}
	
export function CreatedQuestion ({question}) {
	return (
		<div className="page" style={{width:"45%", maxWidth:"800px", height:"auto"}}>
			<div className="enonce">
				<h1 style={{textAlign:"right"}}>{Object.keys(question.selection).join(', ') || 'Chapitre'}</h1>
				<h2>{question.titre} {question.niveau ? '('+question.niveau+')' : ''} {'⭐'.repeat(question.etoile)} </h2>
				<p dangerouslySetInnerHTML={{ __html:question.enonce || 'Enoncé de la question...'}}>
				</p>
			</div>

			<Reponse question={question} />

			<input type="button" className="btn" value="Valider" style={{opacity:'0.3'}} />
		</div>
	);
}